import { z } from 'zod';

/**
 * A KPI that compares against the previous window (D12) — the pair a `StatCard`
 * trend is computed from. `current`/`previous` rather than a pre-computed
 * percentage: a `0` previous value cannot express a rate, and the client's
 * `trend` util is the one place that decides "no comparison" for it.
 */
export const ComparableCountSchema = z
  .object({
    current: z.number().int().nonnegative(),
    previous: z.number().int().nonnegative(),
  })
  .strict();

export type ComparableCount = z.infer<typeof ComparableCountSchema>;

/** One row of a breakdown chart (`BarList`) — a label the client translates by key. */
export const BreakdownRowSchema = z
  .object({
    key: z.string(),
    count: z.number().int().nonnegative(),
  })
  .strict();

export type BreakdownRow = z.infer<typeof BreakdownRowSchema>;
